import _ from 'underscore';
import {
  ImportUpdateEntityPreference,
  ImportUserPreferences,
  ImportAppendDestUrlPreference,
  ImportSearchAndReplaceDestUrlPreference,
  AppendPreferencesForTrackingTemplate,
  SearchAndReplacePreferencesForTrackingTemplate,
  ImportPrefixAndSuffixForStringProperty,
  ImportSearchAndReplaceForStringProperty,
  ImportAdjustmentForNumericProperty,
} from '@bingads-webui-campaign/campaign-ui-schemas';


export function getBlackList(permissions) {
  const isPageFeedEnabled = permissions.IsPageFeedImportOptionEnabled;
  const blacklist = [];

  if (!isPageFeedEnabled) {
    blacklist.push('ImportNewOption_ImportNewPageFeeds');
    blacklist.push('ImportUpdateEntityPreference_UpdatePageFeeds');
  }

  if (!permissions.IsPromotionAdExtensionEnabled) {
    blacklist.push('ImportNewOption_ImportNewPromotionAdExtensions');
    blacklist.push('ImportUpdateEntityPreference_UpdatePromotionAdExtensions');
  }

  return blacklist;
}

export function generateCombinedSchemaObject() {
  const searchAndReplaceSchema = _.clone(ImportSearchAndReplaceForStringProperty);
  // overriding schema here because import options still uses
  // old preference and we need to rename the name so options generated can be unique.

  searchAndReplaceSchema.name = 'SearchAndReplaceForCustomParameters';
  const findAndReplaceSuffixSchema = _.clone(ImportSearchAndReplaceForStringProperty);
  findAndReplaceSuffixSchema.name = 'SearchAndReplaceForFinalURLSuffix';

  return {
    ImportUpdateEntityPreference,
    ImportUserPreferences,
    LandingPageAppendPreference: ImportAppendDestUrlPreference,
    LandingPageReplacePreference: ImportSearchAndReplaceDestUrlPreference,
    AppendTrackingTemplatePreference: AppendPreferencesForTrackingTemplate,
    SearchAndReplacePreferencesForTrackingTemplate,
    SearchAndReplaceForCustomParameters: searchAndReplaceSchema,
    SearchAndReplaceForFinalURLSuffix: findAndReplaceSuffixSchema,
    ImportPrefixAndSuffixForStringProperty,
    ImportSearchAndReplaceForStringProperty,
    ImportAdjustmentForNumericProperty,
  };
}

export function createDisabledUETSelectorClass(uetClass) {
  return class AdvancedOptionsView extends uetClass {
    initialize(options) {
      super.initialize(_.defaults({ enabled: false }), options);
      this.disabled = true;
    }
  };
}
